/** The `compile_mode` user preference: which way of compiling the wiki (own agent or AgentWiki credits) comes first */

import { useMutation, useQueryClient } from '@tanstack/react-query'
import { parseCompileMode, type CompileMode } from '@agentwiki/shared'
import { apiClient } from '../lib/api-client'
import { usePreferences } from './use-preferences'

/** Current mode; 'agent' until preferences load or when they fail */
export function useCompileMode(): CompileMode {
  const { data } = usePreferences()
  return parseCompileMode(data?.compile_mode)
}

export function useSetCompileMode() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: async (mode: CompileMode) => {
      await apiClient.put<{ ok: boolean }>('/api/preferences/compile_mode', { value: mode })
      return mode
    },
    onSuccess: (mode) => qc.setQueryData<Record<string, string>>(['preferences'], (old) => ({ ...old, compile_mode: mode })),
  })
}
